import { render, staticRenderFns } from "./ConfirmEmailPage.vue?vue&type=template&id=1409ba3e&scoped=true"
import script from "./ConfirmEmailPage.vue?vue&type=script&lang=ts"
export * from "./ConfirmEmailPage.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmEmailPage.vue?vue&type=style&index=0&id=1409ba3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1409ba3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1409ba3e')) {
      api.createRecord('1409ba3e', component.options)
    } else {
      api.reload('1409ba3e', component.options)
    }
    module.hot.accept("./ConfirmEmailPage.vue?vue&type=template&id=1409ba3e&scoped=true", function () {
      api.rerender('1409ba3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/auth/ConfirmEmailPage.vue"
export default component.exports